import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Seo from "components/Seo";
import { useGetMypageInfo } from "hooks/morning/useGetMypageInfo";
import { ReactComponent as ArrowBack } from "assets/common/common/arrowBack.svg";

export default function MyPageInfo() {
    const navigate = useNavigate();
    const { data: infoData } = useGetMypageInfo();

    useEffect(() => {
        document.body.style.overflow = "hidden";
        return () => {
            document.body.style.overflow = "auto";
        };
    }, []);

    return (
        <React.Fragment>
            <Seo type="morning" pageTitle="마이페이지" />
            <div className="bg-white min-h-[100dvh] flex fixed z-[88888] inset-0 overflow-hidden">
                <div className="w-full max-w-[680px] mx-auto flex flex-col border-l border-r border-[#dddddd] responsive650:border-none">
                    <div className="relative text-[#262A34] text-[20px] text-center font-[500] py-[16px]">
                        업체 정보
                        <ArrowBack onClick={() => navigate(-1)} className="absolute top-1/2 -translate-y-1/2 left-[16px]" />
                    </div>
                    <div className="overflow-y-auto flex-1 px-[16px] py-[24px]">
                        <p className="font-bold text-[#1B1C1E] text-[18px] mb-[20px]">기본정보</p>
                        <div className="flex flex-col gap-[16px]">
                            <div className="flex justify-between items-center py-[12px]">
                                <p>거래처코드</p>
                                <p>{infoData?.c_code}</p>
                            </div>
                            <div className="flex justify-between items-center py-[12px]">
                                <p>사업자 번호</p>
                                <p>{infoData?.c_company_number}</p>
                            </div>
                            <div className="flex justify-between items-center py-[12px]">
                                <p>상호명</p>
                                <p>
                                    {infoData?.c_company}
                                    <span className="text-[14px] text-[#FF7B2E] font-[500] ml-[5px]">{infoData?.c_month_yn}</span>
                                </p>
                            </div>
                            <div className="flex justify-between items-center py-[12px]">
                                <p>연락처</p>
                                <p>{infoData?.c_phone}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}
